import { render, staticRenderFns } from "./TypeofUser.vue?vue&type=template&id=64f31437&scoped=true&"
import script from "./TypeofUser.vue?vue&type=script&lang=js&"
export * from "./TypeofUser.vue?vue&type=script&lang=js&"
import style0 from "./TypeofUser.vue?vue&type=style&index=0&id=64f31437&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f31437",
  null
  
)

export default component.exports